import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError, timer } from 'rxjs';
import { UserService } from './user.service';
import { map, catchError, retry } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';

export class SalonmonsterHttpClient {
  constructor(
    protected http: HttpClient,
    protected userService: UserService,
    protected readonly errorHandlerService: ErrorHandlerService
  ) {}

  protected createAuthorizationHeader(
    headers: HttpHeaders = new HttpHeaders()
  ): HttpHeaders {
    let token = this.userService.getToken();
    if (typeof token === 'undefined') {
      return headers.set('Content-Type', 'application/json');
    } else {
      return headers
        .set('Authorization', this.userService.getToken())
        .set('Content-Type', 'application/json');
    }
  }

  protected get<T = any>(url): Observable<T> {
    const shouldRetry =
      !url.toLowerCase().includes('stripe') &&
      !url.toLowerCase().includes('bulkemail');
    let request = this.http.get<{ data: T }>(url, {
      headers: this.createAuthorizationHeader(),
    });

    if (shouldRetry) {
      request = request.pipe(retry({ count: 2, delay: () => timer(1000) }));
    }

    return request.pipe(
      map((result) => result.data),
      catchError((err: HttpErrorResponse) =>
        throwError(() => this.errorHandlerService.handleError(err))
      )
    );
  }

  protected post<T = any>(url, data): Observable<T> {
    const shouldRetry =
      !url.toLowerCase().includes('stripe') &&
      !url.toLowerCase().includes('bulkemail');
    let request = this.http.post<{ data: T }>(url, data, {
      headers: this.createAuthorizationHeader(),
    });

    if (shouldRetry) {
      request = request.pipe(retry({ count: 2, delay: () => timer(1000) }));
    }

    return request.pipe(
      map((result) => result.data),
      catchError((err: HttpErrorResponse) =>
        throwError(() => this.errorHandlerService.handleError(err))
      )
    );
  }

  protected put<T = any>(url, data): Observable<T> {
    const shouldRetry =
      !url.toLowerCase().includes('stripe') &&
      !url.toLowerCase().includes('bulkemail');
    let request = this.http.put<{ data: T }>(url, data, {
      headers: this.createAuthorizationHeader(),
    });

    if (shouldRetry) {
      request = request.pipe(retry({ count: 2, delay: () => timer(1000) }));
    }

    return request.pipe(
      map((result) => result.data),
      catchError((err: HttpErrorResponse) =>
        throwError(() => this.errorHandlerService.handleError(err))
      )
    );
  }

  protected delete<T = any>(url, data): Observable<T> {
    const shouldRetry =
      !url.toLowerCase().includes('stripe') &&
      !url.toLowerCase().includes('bulkemail');
    let request = this.http.delete<{ data: T }>(url, {
      headers: this.createAuthorizationHeader(),
      body: data,
    });

    if (shouldRetry) {
      request = request.pipe(retry({ count: 2, delay: () => timer(1000) }));
    }

    return request.pipe(
      map((result) => result.data),
      catchError((err: HttpErrorResponse) =>
        throwError(() => this.errorHandlerService.handleError(err))
      )
    );
  }
}
